import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RouteForm from '../../../../components/masters/route/route/RouteForm';
import RouteTable from '../../../../components/masters/route/route/RouteTable';
import { addRoute, updateRoute, clearRouteEdit } from '../../../../redux/actions/masters/route/route/routeMasterAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';
import { fetchCompanies } from '../../../../redux/actions/masters/company/companyAction';
import { fetchDepartments } from '../../../../redux/actions/masters/department/department/departmentAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .route-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .route-form, .route-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const RoutePage = () => {
  const dispatch = useDispatch();
  const { editingRoute, list: routes } = useSelector((state) => state.routeMaster);
  const users = useSelector(state => state.users.list || []);
  const companies = useSelector(state => state.company.list || []);
  const departments = useSelector(state => state.department.list || []);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchCompanies());
    dispatch(fetchDepartments());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingRoute && editingRoute.route_id) {
        await dispatch(updateRoute(editingRoute.route_id, form));
        setFormError('');
      } else {
        await dispatch(addRoute(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearRouteEdit());
    setFormSuccess('');
    setFormError('');
  };

  // For department name mapping in table
  const departmentsMap = {};
  departments.forEach(dep => { departmentsMap[dep.department_code] = dep; });

  // Define checkCodeExists and pass to RouteForm
  const checkCodeExists = async (code, excludeId) => {
    return routes.some(r => r.route_code === code && r.route_id !== excludeId);
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="route-flex">
        <div style={tableContainer} className="route-table">
          <RouteTable onNew={handleFormReset} departmentsMap={departmentsMap} />
        </div>
        <div style={formContainer} className="route-form">
          <RouteForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingRoute={editingRoute}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            users={users}
            companies={companies}
            departments={departments}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default RoutePage;